import { useState, useRef, useLayoutEffect } from 'react';
import { TelehealthActionsProps } from '../../../search/ResultView/ResultList/TelehealthActions/TelehealthActions';
import { useEventListener } from '../../hooks/useEventListener';
import { ChildrenOnly } from '../../types/ChildrenOnly';
import { HorizontalScrollBoxContainer, HorizontalScrollBoxWrapper } from './HorizontalScrollStyles';

type HorizontalScrollBoxProps = ChildrenOnly & TelehealthActionsProps;

export const HorizontalScrollBox = ({
  variation = 'horizontal',
  children,
}: HorizontalScrollBoxProps) => {
  const [overflowLeft, setOverflowLeft] = useState(false);
  const [overflowRight, setOverflowRight] = useState(false);

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => handleScrollOverflow(), []);

  const onScroll = () => handleScrollOverflow();

  useEventListener('resize', () => handleScrollOverflow());

  const handleScrollOverflow = () => {
    if (!scrollContainerRef.current) return;
    const { scrollWidth, clientWidth, scrollLeft } = scrollContainerRef.current;
    const scrollDistance = clientWidth + scrollLeft;

    setOverflowRight(
      (scrollDistance < scrollWidth || clientWidth < scrollWidth) && scrollDistance !== scrollWidth,
    );

    setOverflowLeft(scrollLeft > 0);
  };

  return (
    <HorizontalScrollBoxContainer overflowLeft={overflowLeft} overflowRight={overflowRight}>
      <HorizontalScrollBoxWrapper
        variation={variation}
        onScroll={onScroll}
        ref={scrollContainerRef}
      >
        {children}
      </HorizontalScrollBoxWrapper>
    </HorizontalScrollBoxContainer>
  );
};
